const DEFAULT_OPEN_WALLET_DEEPLINK_URL = 'uniprosperityone://://?qcOpenWallet';
const DEFAULT_RESET_WALLET_PWD_DEEPLINK_URL =
  'uniprosperityone://://resetWalletPassword';

export const getOpenWalletDeeplinkUrl = () =>
  process.env.GATSBY_OPEN_WALLET_DEEPLINK_URL ||
  DEFAULT_OPEN_WALLET_DEEPLINK_URL;

export const getResetWalletPasswordDeeplinkUrl = () =>
  process.env.GATSBY_RESET_WALLET_PWD_DEEPLINK_URL ||
  DEFAULT_RESET_WALLET_PWD_DEEPLINK_URL;

export const openWalletApp = () => {
  if (typeof window === 'undefined') return;
  window.location.assign(getOpenWalletDeeplinkUrl());
};

export const openResetWalletPasswordPage = () => {
  if (typeof window === 'undefined') return;

  window.location.assign(getResetWalletPasswordDeeplinkUrl());
};
